module.exports = __webpack_public_path__ + "static/img/patho-erosion-high-C8bWfBKd.bcc9fb1a.png";